import React, { useEffect, useState } from "react";
import PlusIcon from "../../assets/icons/plus";
import Popup from "../Common/Popup";
import Input from "../Common/CustomInput";
import GradeTable from "../Common/GradeTable";
import useApiLoader from "../../Utils/useApiLoader";
import Loader from "../Loader/Loader";
import api from "../../setupMiddleware";
import { ToastContainer, toast, Bounce } from "react-toastify";
import { hasPermission } from "../../Utils/auth";

const GradeManagement = () => {
  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [gradeData, setGradeData] = useState([]);
  const [gradeName, setGradeName] = useState("");
  const [gradeEdit, setGradeedit] = useState({});

  console.log("gradeEdit", gradeEdit);
  const loading = useApiLoader();

  const getAllGrades = async () => {
    api.get("/api/grades").then((res) => {
      if (res && res.status === 200) {
        setGradeData(res.data?.data);
        setOpen(false);
        setEditOpen(false);
        setDeleteOpen(false);
      }
    });
  };

  const addNewGrade = async () => {
    api
      .post("/api/grades", { title: gradeName })
      .then((res) => {
        if (res && res.status === 200) {
          toast.success(res.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
          getAllGrades();
        }
      })
      .catch((err) => {
        if (err) {
          alert(err.response?.data?.errors?.name[0]);
        }
      });
  };

  const updateGrade = async () => {
    api
      .put(`/api/grades/${gradeEdit?.id}`, { title: gradeEdit?.title })
      .then((res) => {
        if (res && res.status === 200) {
          toast.success(res.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
          getAllGrades();
        }
      })
      .catch((err) => {
        if (err) {
          alert(err.response?.data?.errors?.name[0]);
        }
      });
  };

  // const deleteGrade = async () => {
  //   api
  //     .delete(`/api/user-grades/${gradeEdit?.id}`)
  //     .then((res) => {
  //       if (res && res.status === 200) {
  //         toast.success(res.data?.message, {
  //           position: "top-left",
  //           autoClose: 5000,
  //           hideProgressBar: false,
  //           closeOnClick: false,
  //           pauseOnHover: true,
  //           draggable: true,
  //           progress: undefined,
  //           theme: "colored",
  //           transition: Bounce,
  //         });
  //         getAllGrades();
  //       }
  //     })
  //     .catch((err) => {
  //       if (err) {
  //         alert(err.response?.data?.errors?.name[0]);
  //       }
  //     });
  // };

  const handleEditGrade = (val) => {
    setGradeedit(val);
    setEditOpen(true);
  };

  // const handleDeleteGrade = (val) => {
  //   setGradeedit(val);
  //   setDeleteOpen(true);
  // };

  useEffect(() => {
    getAllGrades();
  }, []);

  return (
    <>
      {loading && <Loader opacity={90} fullscreen />}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full mx-auto px-4 py-3 gap-4">
        {/* Left Content */}
        <p>
          <span className="block text-xl sm:text-2xl font-medium text-[#de2b26]">
            Grade Management
          </span>
          <span className="block text-sm text-[#142b70]/50">
            Manage All Grades
          </span>
        </p>

        {/* Right Button */}
        <div className="flex">
          {hasPermission("add_grades") && (
            <button
              onClick={() => setOpen(true)}
              className="flex items-center gap-2 px-4 py-2 rounded bg-[#de2b26] hover:bg-[#c30f0a] transition text-white text-sm font-medium"
            >
              <PlusIcon iconClass="w-4 h-4" color="#ffffff" />
              Add New Grade
            </button>
          )}
          <Popup
            isOpen={open}
            onClose={() => setOpen(false)}
            title="Add New Grade"
          >
            <div className="flex flex-col gap-6 mt-[30px]">
              <div className="flex flex-col gap-2">
                <p className="text-sm text-[#142b70]/80">Grade Name</p>
                <div className="relative">
                  <Input
                    type="text"
                    placeholder="G1"
                    value={gradeName}
                    onChange={(e) => setGradeName(e.target.value)}
                  />
                </div>
              </div>
            </div>
            {/* Footer */}
            <div className="flex justify-end gap-4">
              <button
                onClick={() => setOpen(false)}
                className="px-10 py-3.5 rounded-md border border-[#de2b26] text-[#de2b26] font-medium"
              >
                Cancel
              </button>
              <button
                onClick={addNewGrade}
                disabled={gradeName ? false : true}
                className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium disabled:opacity-50"
              >
                Add Grade
              </button>
            </div>
          </Popup>
          {/* Edit Popup */}
          <Popup
            isOpen={editOpen}
            onClose={() => setEditOpen(false)}
            title="Edit Grade"
          >
            <div className="flex flex-col gap-6 mt-[30px]">
              <div className="flex flex-col gap-2">
                <p className="text-sm text-[#142b70]/80">Grade Name</p>
                <div className="relative">
                  <Input
                    type="text"
                    placeholder="G1"
                    value={gradeEdit?.title}
                    onChange={(e) =>
                      setGradeedit({ ...gradeEdit, title: e.target.value })
                    }
                  />
                </div>
              </div>
            </div>
            {/* Footer */}
            <div className="flex justify-end gap-4">
              <button
                onClick={() => setEditOpen(false)}
                className="px-10 py-3.5 rounded-md border border-[#de2b26] text-[#de2b26] font-medium"
              >
                Cancel
              </button>
              <button
                onClick={updateGrade}
                disabled={gradeEdit?.title ? false : true}
                className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium disabled:opacity-50"
              >
                Update Grade
              </button>
            </div>
          </Popup>

          {/* Delete Popup */}
          {/* <Popup
            isOpen={deleteOpen}
            onClose={() => setDeleteOpen(false)}
            title="Delete Grade"
          >
            <div className="flex flex-col gap-6 mt-[30px]">
              <div className="flex flex-col gap-2">
                <p className="text-sm text-[#142b70]/80">
                  Are you sure and want to delete <b>{gradeEdit?.name}</b> Grade?
                </p>
              </div>
            </div>
            
            <div className="flex justify-end gap-4">
              <button
                onClick={() => setDeleteOpen(false)}
                className="px-10 py-3.5 rounded-md border border-[#de2b26] text-[#de2b26] font-medium"
              >
                Cancel
              </button>
              <button
                onClick={deleteGrade}
                className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium disabled:opacity-50"
              >
                Delete Grade
              </button>
            </div>
          </Popup> */}
        </div>
      </div>

      <div className="w-full mx-auto px-4 py-3 relative">
        <div className="w-full mx-auto px-4 py-3 relative rounded-xl bg-white border border-[#a48572]/10">
          <div className="flex flex-col justify-start items-start gap-[20px]">
            <div className="flex flex-col justify-start items-start flex-grow-0 flex-shrink-0 relative gap-5">
              <p className="flex-grow-0 flex-shrink-0 text-base font-medium text-left text-[#142b70]">
                All Grades
              </p>
            </div>
            <GradeTable data={gradeData} handleEdit={handleEditGrade} />
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default GradeManagement;
